import React from 'react';
import { Box, Button, Typography } from '@saviynt/design-system';
import PropTypes from 'prop-types';

import { useInvertedLocalize } from '../../../../utils/localization';

import invertedMessages from './messages';

import './EmptyState.css';

function EmptyState({
  triggerError,
  triggerConflict,
  isTriggerLoading,
  onTrigger,
  onClose,
}) {
  const l = useInvertedLocalize(invertedMessages);

  return (
    <>
      <Box className='EmptyState-body'>
        {triggerError && (
          <Typography
            kind='body2'
            desktop='body2-d'
            mobile='body2-d'
            className='EmptyState-inlineError'>
            {triggerError}
          </Typography>
        )}
        {triggerConflict && (
          <Typography
            kind='body2'
            desktop='body2-d'
            mobile='body2-d'
            className='EmptyState-inlineError'>
            {triggerConflict.message ||
              l('A pre-launch analysis is already running for this campaign.')}
          </Typography>
        )}
        <Box className='EmptyState-empty'>
          {l('No pre-launch analysis has been run for this campaign yet.')}
        </Box>
      </Box>

      <Box className='EmptyState-footer'>
        <Button
          type='button'
          kind='filled'
          size='medium'
          isDisabled={isTriggerLoading || !!triggerConflict}
          onClick={onTrigger}>
          {isTriggerLoading ? l('Starting Analysis…') : l('Start Analysis')}
        </Button>
        <Button type='button' kind='outlined' size='medium' onClick={onClose}>
          {l('Close')}
        </Button>
      </Box>
    </>
  );
}

EmptyState.propTypes = {
  triggerError: PropTypes.string,
  triggerConflict: PropTypes.shape({ message: PropTypes.string }),
  isTriggerLoading: PropTypes.bool.isRequired,
  onTrigger: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

EmptyState.defaultProps = {
  triggerError: null,
  triggerConflict: null,
};

export default EmptyState;
